import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'environments/environment';
import { LocalStorageService } from 'framework/localstorage.service';
import { PreAuthService } from '../pre-auth.service';
import { SharedService } from 'app/shared/services/shared.service';

@Component({
  selector: 'app-expired-link',
  templateUrl: './expired-link.component.html',
  styleUrls: ['./expired-link.component.css']
})
export class ExpiredLinkComponent implements OnInit {
  formType: string;
  authyPolicyType: string = '';
  authorityMap: { [key: string]: string };
  inviteKey?: string;

  constructor(@Inject(MsalService) private authService: MsalService , private route : ActivatedRoute , private localStorage: LocalStorageService 
,private _preAuthService: PreAuthService , private shareService: SharedService) {
    this.authorityMap = {
      'signin': environment.policies.signinMagicLink.authority,
      'password-reset': environment.policies.passwordReset.authority,
      'password-reset-sms': environment.policies.passwordResetSms.authority,
      'update-phonenumber': environment.policies.changePhoneNumber.authority
    };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.formType = params['policyType'];
    });
  }


  onStartAgainClick() {
    this.authyPolicyType = this.localStorage.getItem("authyPolicyType");
    let authority = this.authorityMap[this.authyPolicyType];
    let that = this;
    that.inviteKey = that.localStorage.getItem("inviteKey");
    let email = that.localStorage.getItem("emailAddress");
    if (!!that.inviteKey) {
      that.showGlobalModal();
      that._preAuthService.getInviteAuthEngine(that.inviteKey).subscribe(response => {
        let authyPrefValue = response['authy_pref_value'];
        let mfaType = that.shareService.getMfaType(authyPrefValue);
        if (that.authyPolicyType === 'password-reset' || that.authyPolicyType === 'restart-password-reset') {
          if (mfaType === 'magiclink' || mfaType === 'sms') {
            authority = environment.policies.passwordResetSms.authority;
          } else {
            authority = environment.policies.passwordReset.authority;
          }
        } else if (that.authyPolicyType === 'update-phonenumber') {
          authority = environment.policies.changePhoneNumber.authority;
        } else {
          if (authyPrefValue === "4" && that.authyPolicyType === 'signin') {
            authyPrefValue = "1";
            mfaType = that.shareService.getMfaType(authyPrefValue);
          }
          authority = environment.restartSigninPolicies[mfaType];
        }
        let clientColor = response['client_color'];
        let clientLogoUrl = response['client_logo_url'];
        let clientLocale = response['authy_locale'] ;
        that.localStorage.setItem("authy_locale", response['authy_locale']);
        that.localStorage.setItem('mfaType', mfaType);        

        let state = `client_info=${window.btoa(
          JSON.stringify({
            color: clientColor,
            logo: clientLogoUrl,
            invite: that.inviteKey,
            locale: clientLocale
          })
        )}`;
        that.closeGlobalModal();
        that.authService.loginRedirect({
          authority: authority,
          scopes: environment.scopes,
          state,
          extraQueryParameters: {
            invite: that.inviteKey,
            clientColor: encodeURIComponent(clientColor ?? ''),
            clientLogoUrl: encodeURIComponent(clientLogoUrl ?? ''),
            ui_locales: encodeURIComponent(clientLocale),
          },
          loginHint: email
        });
        return;
      });
    } else {
      if (authority) {
        this.authService.loginRedirect({ authority: authority, scopes: [] });
      } else {
        console.error('Invalid form type');
      }
    }


  }

  showGlobalModal() {
    let globalModal = document.getElementById("globalModal");
    globalModal.style.display = "block";
  }

  closeGlobalModal() {
    let globalModal = document.getElementById("globalModal");
    globalModal.style.display = "none";
  }

}
